module.exports = __webpack_public_path__ + "488430918129202b5377e0200a98d7f9.png";